export default [
  {
    id: 1,
    label: 'Обработано',
    value: true,
  },
  {
    id: 2,
    label: 'Не обработано',
    value: false,
  },
];
